<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-2"></div>
      <div class="col-sm-3">
        <button
          type="button"
          class="btn btn-success btn-block"
          @click="getReport"
        >
          <i class="fas fa-redo"></i> ประมวลผล
        </button>
      </div>
      <div class="col-sm-3">
        <form
          action="http://localhost/pos_ui/POS/static/pdf/report_sale_credit_detail.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-primary btn-block"
          >
            <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
          </button>
        </form>
      </div>
      <div class="col-sm-3">
        <form
          action="/static/excel/report_sale_credit_detail.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-info btn-block"
          >
            <i class="far fa-file-excel"></i> บันทึกเป็น Excel
          </button>
        </form>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <div class="table-responsive-sm mt-3">
      <table class="table">
        <thead>
          <tr class="text-left">
            <td colspan="6">จุดขาย: {{ host.host_name }}</td>
          </tr>
          <tr class="text-left">
            <td colspan="6">วันที่: <span>{{ dateFormatDMY(startDate) }}</span>
              <span v-if="dateFormatDMY(startDate) !== dateFormatDMY(endDate)">ถึง วันที่: {{ dateFormatDMY(endDate) }}</span>
            </td>
          </tr>
        </thead>
        <tbody
          v-for="(r, i) in report_data"
          :key="'datar' + i"
        >
          <tr class="text-left thead-dark">
            <td colspan="2">เลขที่ใบเสร็จ: {{ r.doc_no }}</td>
            <td>เวลา: {{ dateTimeFormatDMY(r.create_time) }}</td>
            <td class="text-right">ส่วนลดใบเสร็จ: {{ numberFormatDecimal(r.discount_amount) }}</td>
            <td
              colspan="2"
              class="text-right"
            >เฉพาะราคาขาย: all</td>
          </tr>
          <tr class="thead-dark">
            <th width="15%">บาร์โค้ด</th>
            <th width="25%">รายละเอียด</th>
            <th width="20%">ราคาขาย/หน่วยนับ</th>
            <th width="15%">จำนวน</th>
            <th width="15%">ส่วนลด</th>
            <th width="20%">ราคารวม</th>
          </tr>
          <tr
            v-for="(sub, i) in r.sub"
            :key="'subs' + i"
          >
            <td class="text-center">{{ sub.item_barcode }}</td>
            <td class="text-left">{{ sub.item_name }}</td>
            <td class="text-right">{{ numberFormatDecimal(sub.price) }}</td>
            <td class="text-right">{{ numberFormatDecimal(sub.cn_qty) }}</td>
            <td class="text-right">0.00</td>
            <td class="text-right">{{ numberFormatDecimal(sub.amount) }}</td>
          </tr>
          <tr>
            <th colspan="3" class="text-left">ลูกค้า: {{ r.ar_name || '-' }}</th>
            <th
              colspan="3"
              class="text-right"
            >### รวมรายการสินค้าจำนวน: {{ r.sub.length }} ###</th>
          </tr>
          <tr>
            <th
              colspan="3"
              class="text-left"
            >พนักงานเก็บเงิน: {{ r.user_name }} ({{ r.role_name }})</th>
            <th class="text-right">{{ numberFormatDecimal(sum_qty(r.sub)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(0) }}</th>
            <th class="text-right">{{ numberFormatDecimal(r.total_amount) }}</th>
          </tr>
        </tbody>
        <tbody v-if="report_data.length === 0">
          <tr>
            <th
              scope="row"
              colspan="6"
            >ไม่มีข้อมูล</th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '../../services/service_report'

export default {
  props: ['host', 'startDate', 'endDate', 'startTime', 'endTime'],
  data () {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: JSON.stringify(this.host)
    }
  },
  methods: {
    getReport () {
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: this.$store.state.user.branch_id,
        begin_date: this.dateDMY(this.startDate) + ' ' + this.startTime,
        end_date: this.dateDMY(this.endDate) + ' ' + this.endTime
      }
      this.$store.commit('Loading')
      api.saleCreditDetail(
        this.REST_URL,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    sum_qty (obj) {
      var sumQty = 0
      obj.forEach(val => {
        sumQty += val['cn_qty']
      })
      return sumQty
    }
  },
  mounted () {
    this.getReport()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/report/report_sale_credit_detail.vue